/* eslint-disable no-undef */
// export const adoptdevice = (designWidth, rem2px, defaultFontSize) => {
//   console.log(designWidth, rem2px, defaultFontSize)
//   var htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
//   var htmlDom = document.getElementsByTagName('html')[0]
//   if (htmlWidth >= 1360) {
//     htmlDom.style.fontSize = (document.documentElement.clientWidth / 19.2) + 'px'
//     // htmlDom.style.fontSize = htmlWidth / 19.2 + 'px'
//   } else {
//     htmlDom.style.fontSize = '73.3854px'
//   }
// }

import store from "@/store";
import Cookie from "common/js/cookie";
export const defaultFontSize = () => {
  var d = window.document.createElement("div");
  d.style.width = "1rem";
  d.style.display = "none";
  var head = window.document.getElementsByTagName("head")[0];
  head.appendChild(d);
  var defaultFontSize = parseFloat(
    window.getComputedStyle(d, null).getPropertyValue("width")
  );
  if (getBrowserInfo() === "IE" || getBrowserInfo() === "Unkown") {
    d.removeNode(true);
  } else {
    d.remove();
  }
  return defaultFontSize;
};

export const adoptdevice = (designWidth, rem2px, defaultFontSize) => {
  var head = window.document.getElementsByTagName("head")[0];
  document.documentElement.style.fontSize =
    (((window.innerWidth / designWidth) * rem2px) / defaultFontSize) * 100 +
    "%";
  var x =
    (((window.innerWidth / designWidth) * rem2px) / defaultFontSize) * 100 +
    "%";
  var st = document.createElement("style");
  var portrait =
    "@media screen and (min-width: " +
    window.innerWidth +
    "px) {html{font-size:" +
    x +
    "}}";
  // var landscape = "@media screen and (min-width: "+window.innerHeight+"px) {html{font-size:"+ ((window.innerHeight/(designWidth/rem2px)/defaultFontSize)*100) +"%;}}"
  st.innerHTML = portrait;
  head.appendChild(st);
};
/**
 * @name 验证输入框字符长度
 * @author rachel<20190107>第一次修改
 * @description 简单验证一个汉字占2个字符长度
 * @param [min]最小长度
 * @param [max]最大长度
 * @param [value]输入框输入的值（blur后的值）
 * @param [callback]element验证自带的cb函数，必须写上
 * @change [rachel]<20190326>第二次修改，修改方法带最小验证
 */
export const validateCharLength = (min, max, value, callback) => {
  let lenOfchinese = 0; // 中文个数
  var lenOfchar = 0; // 英文其他个数
  // 分别计算个数
  for (let i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
      lenOfchinese++;
    } else {
      lenOfchar++;
    }
  }
  // 验证最大值
  const checkMax = function () {
    if (lenOfchar === 0 && lenOfchinese > max) {
      callback(new Error("最多可以输入" + max + "个汉字"));
    } else if (lenOfchinese === 0 && lenOfchar > 2 * max) {
      callback(new Error("最多可以输入" + 2 * max + "个字符"));
    } else if (
      lenOfchinese !== 0 &&
      lenOfchar !== 0 &&
      2 * lenOfchinese + lenOfchar > 2 * max
    ) {
      callback(
        new Error("最多可以输入" + max + "个汉字或" + 2 * max + "个字符")
      );
    } else {
      // 如果不需要验证最小值直接返回
      if (min === 0) {
        callback();
      } else {
        checkMin();
      }
    }
  };
  // 验证最小值
  const checkMin = function () {
    if (lenOfchinese === 0 && lenOfchar < 2 * min) {
      callback(new Error("最少输入" + 2 * min + "个字符"));
    } else if (lenOfchar === 0 && lenOfchinese < min) {
      callback(new Error("最少输入" + min + "个汉字"));
    } else if (
      lenOfchinese !== 0 &&
      lenOfchar !== 0 &&
      2 * lenOfchinese + lenOfchar < 2 * min
    ) {
      callback(new Error("最少输入" + min + "个汉字或" + 2 * min + "个字符"));
    } else {
      callback();
    }
  };
  // 默认开启最大值验证
  checkMax();
};

export const computTypeDifferentiate = (
  item,
  name,
  judge,
  limi,
  place,
  once
) => {
  // input只能输入数字
  if (item[name] !== "" && item[name].substr(0, 1) === ".") {
    // 修复第一个字符是小数点 的情况.
    item[name] = "";
  }
  item[name] = item[name].replace(/[^\d.]/g, "");
  item[name] = item[name].replace(/\.{2,}/g, "."); // 只保留第一个. 清除多余的
  item[name] = item[name]
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".");
  // eslint-disable-next-line no-useless-escape
  item[name] = item[name].replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
  // item[name] = item[name].replace(/\.{2,}/g, '') // 只保留第一个. 清除多余
  if (!judge && item[name].indexOf(".") < 0 && item[name] !== "") {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    item[name] = parseFloat(item[name]);
  }
  // 禁止小数点
  if (place && item[name].toString().indexOf(".") > 0) {
    item[name] = item[name].replace(".", "");
  }
  // 1个小数点
  if (once && item[name].toString().indexOf(".") > 0) {
    item[name] = item[name].replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3"); // 只能输入一个小数
  }
  if (limi && Number(item[name]) > limi) {
    // 限制大小
    item[name] = limi;
  }
};

// 格式化日期
export const formatDate = (date, fmt) => {
  var o = {
    "M+": date.getMonth() + 1,
    "D+": date.getDate(),
    "h+": date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    "H+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds(),
  };
  var week = {
    0: "\u65e5",
    1: "\u4e00",
    2: "\u4e8c",
    3: "\u4e09",
    4: "\u56db",
    5: "\u4e94",
    6: "\u516d",
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? "\u661f\u671f"
          : "\u5468"
        : "") + week[date.getDay() + ""]
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
// 判断浏览器的类型
export const getBrowserInfo = () => {
  // 取得浏览器的userAgent字符串
  var userAgent = navigator.userAgent;
  var isIE =
    window.ActiveXObject !== undefined && userAgent.indexOf("MSIE") > -1;
  var isFirefox = userAgent.indexOf("Firefox") > -1;
  var isOpera = window.opr !== undefined;
  var isChrome = userAgent.indexOf("Chrome") && window.chrome;
  var isSafari =
    userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Version") > -1;
  if (isIE) {
    return "IE";
  } else if (isFirefox) {
    return "Firefox";
  } else if (isOpera) {
    return "Opera";
  } else if (isChrome) {
    return "Chrome";
  } else if (isSafari) {
    return "Safari";
  } else {
    return "Unkown";
  }
};

export const isRepeatArr = (arr) => {
  let newArr = arr.filter((item) => item);
  if (newArr.length >= 2) {
    return new Set(newArr).size !== newArr.length;
  }
};

// 时间戳
export const timestamp = () => {
  return new Date().getTime();
};

// 登录信息
export const loginInfo = () => {
  try {
    let loginInfo = JSON.parse(sessionStorage.getItem("loginInfo")) || {};
    loginInfo.universityId = config.universityId;
    loginInfo.operatorId = loginInfo.userCode;
    loginInfo.userCode = loginInfo.userCode;
    loginInfo.token =
      sessionStorage.getItem("token") ||
      loginInfo.token ||
      Cookie.getCookie("evaluate_front_login_access_token");
    loginInfo.clientCategory = config.clientCategory;
    return loginInfo;
  } catch (error) {
    console.error(error);
    return {};
  }
};
export const computScore = (min, max) => {
  var total = min;
  var full = max;
  var sum = Math.round(!total || !full ? 0 : (total / full) * 100);
  let val = 0;
  /**
   * @description: 星星展示 改为配置项分数来进行判定
   * @return {*}
   */
  let arr = store.getters.commonality.ObjStarShow || [];
  arr.forEach((item, index) => {
    if (sum > item.greaterThanVal && sum <= item.lessEqualVal) {
      val = (index + 1) * 0.5;
    }
  });
  return val;
  // if (sum >= 95) {
  //     val = 5
  // } else if (sum < 95 && sum >= 90) {
  //     val = 4.5
  // } else if (sum < 90 && sum >= 85) {
  //     val = 4
  // } else if (sum < 85 && sum >= 80) {
  //     val = 3.5
  // } else if (sum < 80 && sum >= 75) {
  //     val = 3
  // } else if (sum < 75 && sum >= 70) {
  //     val = 2.5
  // } else if (sum < 70 && sum >= 65) {
  //     val = 2
  // } else if (sum < 65 && sum >= 60) {
  //     val = 1.5
  // } else if (sum < 60 && sum >= 55) {
  //     val = 1
  // } else {
  //     val = 0
  // }
  // return val
};

/*eslint-disable */
Date.prototype.format = function (fmt) {
  // author: meizz
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  }
  return fmt;
};



// WEBPACK FOOTER //
// ./src/common/js/util.js